// Fix the confict suggestion search in Debut theme
if (typeof theme !== "undefined" && theme.hasOwnProperty("settings"))
  theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
  general: {
    breakpointMobile: "0",
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    // Placeholder
    showPlaceholderProductList: true,
    swatchStyle: "circle-list",
    separateRefineByFromFilter: true,
    filterTreeMobileStyle: "style2", // 'style2', 'style3',
  },
};

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    firstVariant = {},
    boostPFSImgDefaultSrc =
      "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    boostPFSRangeWidths = [
      180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048,
    ];

  BoostPFS.inject(this);

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    var productBadge = data.tags.find((tag) => tag.includes("badge:"));
    if (productBadge) {
      badgeText = productBadge.split(":");
      data.badgeText = badgeText[badgeText.length - 1].trim();
    } else {
      var lowStockOverride = data.tags.find((tag) =>
        tag.includes("no-low-stock")
      );
      if (!lowStockOverride) {
        var lowQtyThreshold = 6;
        if (data.vendor !== "Hawkins New York") {
          lowQtyThreshold = 3;
        }
        //disable low stock badge for now
        lowQtyThreshold = -1;
        if (firstVariant.inventory_quantity <= lowQtyThreshold) {
          data.badgeText = "Low Stock";
        }
      }
    }

    //window.productCard[data.id] = data;
    var grouped_collection = data.tags.find((tag) => tag.includes("grouped:"));
    if (grouped_collection) {
      grouped_collection_handle = grouped_collection.split(":");
      data.grouped_collection_handle =
        grouped_collection_handle[grouped_collection_handle.length - 1].trim();

      var urlToGet =
        "/collections/" + data.grouped_collection_handle + "/products.json";
      //		$.ajaxSetup({async: false});
      /*
 				$.getJSON(urlToGet, null,
 					function (data, textStatus, jqXHR) {
 						window.groupedCollections[data.grouped_collection_handle] = data.products;
 					}
 				);
 				*/
    }

    //	console.log(window.groupedCollections)

    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  data_counter = 0;
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    // Get Template
    // var itemHtml = boostPFSTemplate.productGridItemHtml;

    /* Start-Boost-233992 */
    if (!index) index = this.index;
    var itemHtml = "";
    var isMobile = jQ(window).width() <= 991;

    var itemHtml = boostPFSTemplate.productGridItemHtml;
    /* End-Boost-233992 */

    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
    var saleClass = onSale ? boostPFSTemplate.saleClass : "";

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

    //quickPanelClass
    itemHtml = itemHtml.replace(/{{quickPanelClass}}/g, quickPanelHeight(data));

    // itemHtml = itemHtml.replace(/{{itemBtn}}/g, buildAtcBtn(data));

    // itemHtml = itemHtml.replace(/{{itemVariantOptions}}/g, buildProductOptions(data));

    var product_title_parts = data.title.split(" -");
    var product_title = product_title_parts[0].trim();
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, product_title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );
    itemHtml = itemHtml.replace(/{{productId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{defaultVariantId}}/g, data.variants[0].id);
    itemHtml = itemHtml.replace(
      /{{initialPrice}}/g,
      "$" + data.variants[0].price
    );
    //console.log('111', window.groupedCollections[data.grouped_collection_handle]);
    //	console.log('itemHtml', itemHtml);

    // var thecurrentPage = parseInt(Globals.queryParams.page);
    // var paginatedCount = ((thecurrentPage - 1) * 48)
    // var positionWithpage = (data_counter + paginatedCount);
    // var calloutCheck = window.masterCalloutData.find((callout) => callout.position == positionWithpage);

    // console.log('istherecalloutcheck', calloutCheck, "thecalloutpositionis", positionWithpage);
    /* condensed 
     	 if (calloutCheck) {
			var calloutBlock = '<div class="card plp_callout"> <img src="' + calloutCheck.image + '" class="card-img-top" alt="..."><div class="card-body px-0 pb-0 pt-1 text-right"> <a href="' + calloutCheck.link + '" class="stretched-link">'+ calloutCheck.cta +'</a></div> </div>';
			itemHtml = calloutBlock + itemHtml;
		}
       */
    /* original
      		if (calloutCheck) {
			var calloutBlock = '<div class="card plp_callout"> <img src="' + calloutCheck.image + '" class="card-img-top" alt="...">';
			calloutBlock += '<img src="' + calloutCheck.image + '" class="card-img-top" alt="...">';
			calloutBlock += '<div class="card-body px-0 pb-0 pt-1 text-right">';
			calloutBlock += '<a href="' + calloutCheck.link + '" class="stretched-link">'+ calloutCheck.cta +'</a>';
			calloutBlock += '</div> </div>';
			itemHtml = calloutBlock + itemHtml;
		}
        */

    //   	if (calloutCheck) {
    // 	var calloutBlock = '<div class="card plp_callout"> <img src="' + calloutCheck.image + '" class="card-img-top" alt="...">';
    //       if (calloutCheck.cta) {
    // 	calloutBlock += '<div class="card-body px-0 pb-0 pt-1 text-right">';
    // 	calloutBlock += '<a href="' + calloutCheck.link + '" class="stretched-link">'+ calloutCheck.cta +'</a>';
    //     }
    // 	calloutBlock += '</div> </div>';
    // 	itemHtml = calloutBlock + itemHtml;
    // }

    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/

  function buildImages(data) {
    //console.log(data.tags);

    var html = "",
      aspectRatio = "",
      rangeWidths = boostPFSRangeWidths,
      paddingTop = 100;

    var dataSrcSet = "",
      dataWidths = "",
      dataSizes = "auto",
      imgAlt = data.title,
      flipImageSrcSet = "";

    var activeSwapImage =
      !Utils.isMobile() &&
      images.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") &&
      boostPFSThemeConfig.custom.active_image_swap == true;

    for (var i = 0; i < rangeWidths.length; i++) {
      dataSrcSet +=
        Utils.getFeaturedImage(images, rangeWidths[i] + "x") +
        " " +
        rangeWidths[i] +
        "w";
      dataWidths += rangeWidths[i];

      if (activeSwapImage) {
        flipImageSrcSet +=
          Utils.optimizeImage(images[1]["src"], rangeWidths[i] + "x") +
          " " +
          rangeWidths[i] +
          "w";
      }

      if (i < rangeWidths.length - 1) {
        dataSrcSet += ", ";
        dataWidths += ", ";

        if (activeSwapImage) {
          flipImageSrcSet += ", ";
        }
      }
    }

    if (images.length > 0) {
      aspectRatio = images[0]["width"] / images[0]["height"];
      paddingTop = (1 / aspectRatio) * 100;
    }
    /*
		html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-linkX" ';
		//html += 'style="padding-top:' + paddingTop + '%;">';
		html += '>';
		html += '<img class="boost-pfs-filter-product-item-main-imageX lazyload Image--lazyLoad card-img-top"' +
			'data-srcset="' + dataSrcSet + '" ' +
			'data-src="' + Utils.getFeaturedImage(images, rangeWidths[2] + 'x') + '" ' +
			'data-widths="[' + dataWidths + ']" ' +
			'data-sizes="' + dataSizes + '" ' +
			'src="' + boostPFSImgDefaultSrc + '" ' +
			'alt="' + imgAlt + '" ';

		if (activeSwapImage) {
			html += 'data-img-flip-src="' + Utils.optimizeImage(images[1]['src'], rangeWidths[2] + 'x') + '" ' +
				'data-img-flip-srcset="' + flipImageSrcSet + '" ';
		}
	
		html += '/></a>';
*/
    html += '<a href="{{itemUrl}}" class="" ';
    html += ">";
    
    if (data.badgeText == "sale") {
      html +=
        '<div class="product_card_badge sale">' + data.badgeText + "</div>";
    } else if (data.badgeText == "bundle") {
      html +=
        '<div class="product_card_badge bundle_badge">' +
        data.badgeText +
        " <br>+ save" +
        "</div>";
    } else if (data.badgeText == "supersale") {
      html += '<div class="product_card_badge supersale"> SALE <br> ON <br> SALE </div>' ;
    } else if (data.badgeText) {
      html += '<div class="product_card_badge">' + data.badgeText + "</div>";
    }
    html += '<img class="card-img-top" ';
    html += 'alt="' + imgAlt + '" ';
    html +=
      'src="' + Utils.getFeaturedImage(images, rangeWidths[2] + "x") + '"';
    if (images[1]) {
      html +=
        'data-img-alt="' +
        Utils.optimizeImage(images[1]["src"], rangeWidths[2] + "x") +
        '"';
    }
    html += ' loading="lazy"/> ';
    html += "</a>";

    return html;
  }

  function buildPrice(data) {
    var html = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_price") &&
      boostPFSThemeConfig.custom.show_price
    ) {
      //	html = '<p class="boost-pfs-filter-product-item-price">';

      if (onSale) {
        html +=
          '<span class="boost-pfs-filter-product-item-sale-price">' +
          Utils.formatMoney(data.price_min) +
          "</span>";
        html +=
          '<span class="sr-only">original price:</span>' +
          "<s>" +
          Utils.formatMoney(data.compare_at_price_min) +
          "</s> ";
      } else {
        if (priceVaries) {
          html +=
            '<span class="boost-pfs-filter-product-item-price-from-text">' +
            boostPFSThemeConfig.label_basic.from +
            " " +
            "</span>";
        }
        html +=
          '<span class="boost-pfs-filter-product-item-regular-price">' +
          Utils.formatMoney(data.price_min) +
          "</span>";
      }
      //	html += '</p>';
    }
    return html;
  }

  function handleize(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove all non-word chars
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  }
  function quickPanelHeight(data) {
    //{% if product.variants.size == 1 and product.selected_or_first_available_variant.title == 'Default Title' %}not_full_height{% endif %}
    if (data.variants[0].title.toLowerCase() == "default title") {
      return "not_full_height";
    }
    return "";
  }

  function buildAtcBtn(data) {
    var toReturn =
      '<button class="btn btn-atc quick_panel_btn-atc text-uppercase" data-product-id="' +
      data.id +
      '" data-variant-id="' +
      data.variants[0].id +
      '">Add to Cart - \
		<span class="product_card_price_wrapper">$' +
      data.variants[0].price +
      "</span></button>";
    return toReturn;
  }

  function buildProductOptions(data) {
    var optionsOutput = "";
    //check out grouped product
    //check if grouped collections exists in array
    //if not grab grouped products and store into array to use

    //window.groupedCollections
    var groupedVariantOption2 = "";
    var productOptionsValueArray = [];
    if (data.grouped_collection_handle) {
      var currentProductColor = data.title.split(" -");
      currentProductColor =
        currentProductColor[currentProductColor.length - 1].trim();
      var urlToGet =
        "/collections/" + data.grouped_collection_handle + "/products.json";
      //		$.ajaxSetup({async: false});
      var colorSwatchValue = "";
      if (!window.groupedCollections[data.grouped_collection_handle]) {
        $.ajaxSetup({ async: false });

        $.getJSON(urlToGet, null, function (data, textStatus, jqXHR) {
          window.groupedCollections[data.grouped_collection_handle] =
            data.products;
          var colorOptions = "";
          $.each(data.products, function (productIndex, product) {
            window.productCard[product.id] = product;
            //	console.log(product);
            colorSwatchValue = "";
            $.each(product.tags, function (_tagIndex, tag) {
              var cleanedTag = tag.toLowerCase();
              var tagParts = cleanedTag.split(":");
              if (tagParts[0] == "grouped_by") {
                var groupedSwatch = tagParts[1].trim();
              }
              if (tagParts[0] == "swatch") {
                colorSwatchValue = tagParts[1].trim();
              }
            });
            colorOptions +=
              '<option data-product-id="' +
              product.id +
              '" value="' +
              colorSwatchValue +
              '">' +
              colorSwatchValue.capitalize() +
              "</option>";
            groupedVariantOption2 = product.options[0].name;
            if (productIndex == 0) {
              var productUrl = "products/" + product.handle;
              var featuredImage = product.images[0];
              var productOptionsValues = window.groupedCollections[
                data.grouped_collection_handle
              ].map((a) => a.options);
              productOptionsValueArray = [];
              $.each(
                productOptionsValues,
                function (indexInArray, productOptionValue) {
                  productOptionsValueArray = productOptionsValueArray.concat(
                    productOptionValue[0].values
                  );
                }
              );
              productOptionsValueArray = uniqArray(productOptionsValueArray);
            }
          });

          //	var mainLoopIndex = indexInArray + 1;
          //var selectedVaraint = data.variants[0];
          var toReturn = "";

          toReturn += '<div class="variant_select_wrapper">';
          toReturn += '<div class="flex flex-row">';
          toReturn += '<p class="variant_type_label d-inline-block">Color</p>';
          toReturn +=
            '<p class="selected_variant_type d-inline-block">' +
            currentProductColor +
            "</p>";
          toReturn += "</div>";
          toReturn +=
            '<div class=" btn-group-toggle variant_type_color" data-toggle="buttons">';
          $.each(data.products, function (groupedProductIndex, groupedProduct) {
            $.each(groupedProduct.tags, function (_tagIndex, tag) {
              var cleanedTag = tag.toLowerCase();
              var tagParts = cleanedTag.split(":");

              if (tagParts[0] == "swatch") {
                colorSwatchValue = tagParts[1].trim();
              }
            });
            var valueName = groupedProduct.title.split("-");
            valueName = valueName[valueName.length - 1].trim();
            var currentProductColorClean = currentProductColor.toLowerCase();

            toReturn += '<label class="btn btn-outline ';
            if (currentProductColorClean == colorSwatchValue) {
              toReturn += " active ";
            }
            toReturn += " swatch_color_" + handleize(colorSwatchValue) + '">';
            toReturn +=
              '<input type="radio" class="variant_swatch  grouped_variant_product quick_panel_grouped_option" ';
            toReturn +=
              ' data-option="option2" data-product-id="' +
              groupedProduct.id +
              '" value="' +
              valueName +
              '"';
            toReturn +=
              ' data-index="option2" data-type="color" name="color_' +
              data.id +
              '"';
            toReturn +=
              ' id="ProductSelect-option-color-' +
              colorSwatchValue +
              '" qp-variant-select';

            if (currentProductColorClean == colorSwatchValue) {
              toReturn += " checked ";
            }

            toReturn += ">";
            toReturn += " </label>";
          });

          toReturn += "</div>";
          toReturn += "</div>";
          optionsOutput += toReturn;

          var toReturn = "";
          if (
            groupedVariantOption2.toLowerCase() == "title" &&
            productOptionsValueArray.length == 1 &&
            productOptionsValueArray[0].toLowerCase() == "default title"
          ) {
          } else {
            toReturn += '<div class="variant_select_wrapper">';
            toReturn += '<div class="flex flex-row">';
            toReturn +=
              '<p class="variant_type_label d-inline-block">' +
              groupedVariantOption2 +
              "</p>";
            toReturn += "</div>";
            toReturn +=
              '<div class=" btn-group-toggle variant_type_' +
              handleize(groupedVariantOption2) +
              '" data-toggle="buttons">';
            productOptionsValueArray = productOptionsValueArray.reverse();
            $.each(productOptionsValueArray, function (valueIndex, value) {
              //{% if current_product_color_clean == colorSwatchValue %} active {% endif %}
              toReturn += '<label class="btn btn-outline " >';
              toReturn +=
                '<input type="radio" class="quick_panel_variant_option grouped_variant_product  " data-option="option1" ';
              toReturn += ' name="option_selection_1" value="' + value + '"';
              if (valueIndex == 0) {
                toReturn += " checked ";
              }
              // {% if product.options_with_values[0].selected_value == value %} checked {% endif %}
              toReturn += " qp-variant-select>";
              toReturn += '<span class="">' + value + "</span";
              toReturn += "/> ";
              toReturn += " </label>";
            });

            toReturn += "</div>";
            toReturn += "</div>";
          }

          optionsOutput += toReturn;
        });
        return optionsOutput;
      }
    } else {
      if (data.variants[0].title.toLowerCase() == "default title") {
        return optionsOutput;
      }
      $.each(data.options_with_values, function (indexInArray, productOption) {
        var mainLoopIndex = indexInArray + 1;
        var selectedVaraint = data.variants[0];
        var toReturn = "";
        var currentOption = selectedVaraint["option" + (indexInArray + 1)];
        toReturn +=
          '<div class="variant_select_wrapper"><div class="flex flex-row">';
        toReturn +=
          '<p class="variant_type_label d-inline-block">' +
          productOption.name.toProperCase() +
          "</p>";
        if (productOption.name.toLowerCase() == "color") {
          toReturn +=
            '<p class="selected_variant_type d-inline-block">' +
            currentOption +
            "</p>";
        }
        toReturn +=
          '<div class=" btn-group-toggle variant_type_' +
          handleize(productOption.name) +
          '" data-toggle="buttons">';

        $.each(productOption.values, function (indexInArray, value) {
          toReturn += '<label class="btn btn-outline ';
          if (currentOption == value.title) {
            toReturn += " active ";
          }
          toReturn += " swatch_color_" + handleize(value.title) + '">';

          toReturn +=
            '<input type="radio" class="quick_panel_variant_option" data-option="option' +
            mainLoopIndex +
            '"';
          toReturn +=
            'name="option_selection_' +
            mainLoopIndex +
            '" value="' +
            value.title +
            '" qp-variant-select';
          if (currentOption == value.title) {
            toReturn += " checked ";
          }
          toReturn += ">";
          toReturn += '<span class="';
          if (productOption.name.toLowerCase() == "color") {
            toReturn += "sr-only";
          }
          toReturn += '">' + value.title + "</span>";

          toReturn += "</label>";
        });

        toReturn += "</div>";
        toReturn += "</div></div>";
        optionsOutput += toReturn;
      });
      return optionsOutput;
    }
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  function addRelAttributesToPagination(paginationHtml, currentPage) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${paginationHtml}</div>`, 'text/html');
    
    const links = doc.querySelectorAll('a');
    
    links.forEach((link, index) => {
      const href = link.getAttribute('href');
      const text = link.innerHTML.trim();  
      if (text === '&larr;') {
        link.setAttribute('rel', 'prev');
      }
      else if (text === '&rarr;') {
        link.setAttribute('rel', 'next');
      }
      else if (href) {
        const pageMatch = href.match(/page=(\d+)/);      
        if (pageMatch) {
          const pageNum = parseInt(pageMatch[1]);
          if (pageNum === currentPage - 1) {
            link.setAttribute('rel', 'prev');
          } else if (pageNum === currentPage + 1) {
            link.setAttribute('rel', 'next');
          }
        }
      }
    });
    const result = doc.querySelector('div').innerHTML;
    return result;
  }
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return "";
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml =
      currentPage > 1
        ? boostPFSTemplate.previousActiveHtml
        : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage - 1)
    );
    if (currentPage > 1) {
      previousHtml = previousHtml.replace(/<a /g, '<a aria-label="Go to previous page" ');
    } else {
      previousHtml = previousHtml.replace(/&larr;/g, '<span aria-hidden="true">&larr;</span>');
    }
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml =
      currentPage < totalPage
        ? boostPFSTemplate.nextActiveHtml
        : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage + 1)
    );
    if (currentPage < totalPage) {
      nextHtml = nextHtml.replace(/<a /g, '<a aria-label="Go to next page" ');
    } else {
      nextHtml = nextHtml.replace(/&rarr;/g, '<span aria-hidden="true">&rarr;</span>');
    }
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 3 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift("...");
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 3 && iAfter <= totalPage;
      iAfter++
    ) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push("...");
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = "";
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == "...") {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? boostPFSTemplate.pageItemSelectedHtml
            : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return addRelAttributesToPagination(paginationHtml, currentPage);
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (
      boostPFSThemeConfig.custom.show_toolbar_sort_by &&
      boostPFSTemplate.hasOwnProperty("sortingHtml")
    ) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || "";
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          activeClass = "";
          if (paramSort == k) {
            activeClass = "boost-pfs-filter-sort-item-active";
          }
          sortingItemsHtml +=
            '<li class="' +
            activeClass +
            '"><a href="#" data-sort="' +
            k +
            '" class="' +
            activeClass +
            '">' +
            sortingArr[k] +
            "</a></li>";
        }
        html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (
      jQ(".boost-pfs-filter-custom-sorting").hasClass(
        "boost-pfs-filter-sort-active"
      )
    ) {
      jQ(".boost-pfs-filter-custom-sorting").toggleClass(
        "boost-pfs-filter-sort-active"
      );
    }

    var labelSort = "";
    var paramSort = Globals.queryParams.sort || "";
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting_heading;
    }

    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      jQ(".boost-pfs-filter-custom-sorting button span span").text("clear");
    }
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    var _this = this;
    jQ(".boost-pfs-filter-filter-dropdown a").click(function (e) {
      e.preventDefault();
      FilterApi.setParam("sort", jQ(this).data("sort"));
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
      announceSortChange(sortLabel);
    });

    jQ(
      ".boost-pfs-custom-sorting .boost-pfs-filter-top-sorting-wrapper span span"
    ).click(function (e) {
      e.preventDefault();
      FilterApi.setParam("sort", boostPFSAppConfig.general.default_sort_by);
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
    });

    jQ(".boost-pfs-filter-custom-sorting .boost-pfs-filter-top-sorting-wrapper .boost-pfs-filter-top-sorting-title").click(
      function () {
        if (!jQ(".boost-pfs-filter-filter-dropdown").is(":animated")) {
          jQ(".boost-pfs-filter-filter-dropdown")
            .toggle()
            .parent()
            .toggleClass("boost-pfs-filter-sort-active");
        }
      }
    );

    jQ(Selector.filterTreeMobileButton).click(function () {
      jQ(
        ".boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown"
      ).hide();
    });
  };
  // For Toolbar - Build Display type

  var originalRenderProductDisplayType = ProductDisplayType.prototype.render;
  ProductDisplayType.prototype.render = function () {
    // Call the original function in our app lib.
    // We don't have to copy a very big function out here to modify.
    // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
    originalRenderProductDisplayType.call(this);

    // Do your custom code after the original function has run
    // Active current display type
    if (this.$element.length) {
      this.$element
        .find(this.selector.productDisplayTypeList)
        .removeClass("active");
      this.$element
        .find(this.selector.productDisplayTypeGrid)
        .removeClass("active");
      if (Globals.queryParams.display == "list") {
        this.$element
          .find(this.selector.productDisplayTypeList)
          .addClass("active");
      } else if (Globals.queryParams.display == "grid") {
        if (
          boostPFSThemeConfig.custom.view_as_type ==
            "view_as_type_list_grid_multi_col" &&
          !Utils.isMobile()
        ) {
          var curentGridColumn = boostPFSThemeConfig.custom.products_per_row;
          this.$element
            .find(this.selector.productDisplayTypeGrid)
            .each(function () {
              var $parent = jQ(this).parent();
              var $cssNames = jQ(".boost-pfs-filter-top-display-type")
                .attr("class")
                .split(" ");
              var $activeClass = $cssNames[$cssNames.length - 1];
              var indexCurrentColumn =
                $activeClass.split("-")[$activeClass.split("-").length - 1];

              if (
                $parent.hasClass("boost-pfs-filter-view-as-click") &&
                jQ(this).data("view") == $activeClass
              ) {
                jQ(this).addClass("active");
                jQ(".boost-pfs-filter-product-item")
                  .removeClass(function (index, css) {
                    return (
                      css.match(/(^|\s)boost-pfs-filter-grid-width-\S+/g) || []
                    ).join(" ");
                  })
                  .addClass(
                    "boost-pfs-filter-grid-width-" + indexCurrentColumn
                  );
              } else if (
                !$parent.hasClass("boost-pfs-filter-view-as-click") &&
                jQ(this).data("view").split("-")[1] == curentGridColumn
              ) {
                jQ(this).addClass("active");
              }
            });
        } else {
          this.$element
            .find(this.selector.productDisplayTypeGrid)
            .addClass("active");
        }
      }
    }
  };

  /************************** END BUILD TOOLBAR **************************/
  // LAST ELEMENT START

  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    const $productCards = jQuery(".boost_product_card");
    const totalProductsOnPage = $productCards.length;

    $productCards.each(function (index) {
      var adletHtml = "";
      var isMobile = jQuery(window).width() <= 991;
      const isLastProduct = index === totalProductsOnPage - 1;
      var hasLastPositionMatch = false;

      // Only process if the global banner settings exist and we have a page parameter.
      if (
        typeof boostPFSCustomBanner !== "undefined" &&
        Globals?.queryParams?.page
      ) {
        const currentPage = parseInt(Globals.queryParams.page, 10);

        for (let i = 1; i <= 40; i++) {
          let positionKey = `banner_position_${i}`;
          let imageMobileKey = `banner_image_mobile_${i}`;
          let imageDesktopKey = `banner_image_desktop_${i}`;
          let textKey = `banner_text_${i}`;
          let linkKey = `banner_link_${i}`;
          let descriptionKey = `banner_description_${i}`;
          let wrapLinkFlagKey = `banner_wrap_link_${i}`;
          let wrapTextKey = `banner_wrap_text_${i}`;
          let bannerSizeKey = `banner_size_${i}`;
          let pageKey = `banner_page_${i}`;

          let bannerPage = boostPFSCustomBanner[pageKey] || 1;

          if (currentPage === bannerPage) {
            // --------- Double/Hero banners logic ----------
            if (
              boostPFSCustomBanner[positionKey] ==
              index + boostPFSCustomBanner[bannerSizeKey]
            ) {
              let bannerImage = "";
              let bannerLink = "";
              let wrapLinkFlag = boostPFSCustomBanner[wrapLinkFlagKey];

              if (isMobile && boostPFSCustomBanner[imageMobileKey] !== null) {
                bannerImage = boostPFSCustomBanner[imageMobileKey];
              } else if (
                !isMobile &&
                boostPFSCustomBanner[imageDesktopKey] !== null
              ) {
                bannerImage = boostPFSCustomBanner[imageDesktopKey];
              }

              if (bannerImage !== "") {
                bannerLink = boostPFSCustomBanner[linkKey] || "";
                let gridClass =
                  boostPFSCustomBanner[bannerSizeKey] === 0
                    ? "half-width"
                    : "full-width";

                adletHtml += `<div class="card product_card boost_product_card_banner boost-pfs-filter-auto-height boost_product_card_banner-${i} ${gridClass}">`;

                if (wrapLinkFlag == "true") {
                  adletHtml += '<div class="boost_product_card_banner_img">';
                  adletHtml += `<a href="${bannerLink}"></a>`;
                  adletHtml += `<img src="${bannerImage}" alt="${
                    boostPFSCustomBanner[textKey] || ""
                  }" />`;
                  adletHtml += "</div>";
                  adletHtml += `<div class="boost_product_card_banner-description">${
                    boostPFSCustomBanner[descriptionKey] || ""
                  }</div>`;
                } else {
                  adletHtml += `<img src="${bannerImage}" alt="${
                    boostPFSCustomBanner[textKey] || ""
                  }" />`;
                  adletHtml += `<div class="boost_product_card_banner-description">${
                    boostPFSCustomBanner[descriptionKey] || ""
                  }</div>`;
                  adletHtml += `<a class="boost_product_card_banner_links" href="${bannerLink}">${
                    boostPFSCustomBanner[wrapTextKey] || "Shop now"
                  }</a>`;
                }
                adletHtml += "</div>";
              }
            } // end double/hero banner condition

            // --------- Single grid item banners logic ----------
            let singleGridSpotKey = `single_grid_spot_${i}`;
            let singleImageKey = `single_image_${i}`;
            let singleImageMobileKey = `single_image_mobile_${i}`;
            let singleImageLinkKey = `single_image_link_${i}`;
            let singleAltTextKey = `single_alt_text_${i}`;

            const requestedPositionRaw =
              boostPFSCustomBanner[singleGridSpotKey];

            if (
              requestedPositionRaw === undefined ||
              requestedPositionRaw === null
            ) {
              continue;
            }

            const isLastPositionRequested =
              typeof requestedPositionRaw === "string" &&
              requestedPositionRaw.toLowerCase() === "last";

            const requestedPosition = !isLastPositionRequested
              ? parseInt(requestedPositionRaw, 10) || -1
              : -1;

            const positionMatches =
              requestedPosition === index + 1 ||
              (isLastPositionRequested && isLastProduct);

            if (positionMatches) {
              if (isLastPositionRequested && isLastProduct) {
                hasLastPositionMatch = true;
              }

              let singleImage = isMobile
                ? boostPFSCustomBanner[singleImageMobileKey]
                : boostPFSCustomBanner[singleImageKey];
              if (singleImage !== null) {
                let singleLink = boostPFSCustomBanner[singleImageLinkKey] || "";
                adletHtml += `<div class="card product_card boost_product_card boost_product_card_banner boost_product_card_banner-${i}">`;
                adletHtml += '<div class="boost_product_card_banner_image">';
                adletHtml += `<a class="boost_product_card_banner_link" href="${singleLink}">`;
                adletHtml += `<img src="${singleImage}" alt="${
                  boostPFSCustomBanner[singleAltTextKey] || ""
                }" />`;
                adletHtml += "</a></div>";
                adletHtml += "</div>";
              }
            }
          }
        }
      }

      if (adletHtml !== "") {
        if (isLastProduct && hasLastPositionMatch) {
          jQuery(this).after(adletHtml);
        } else {
          jQuery(this).before(adletHtml);
        }
      }
    });

    if (data.products && data.products.length) {
      data.products.forEach(function (product, idx) {});
    }

    $.each(data, function (_indexInArray, product) {
      jQ(
        ".boost-pfs-filter-product-item-regular-price, .product_card_price span, .product_card_price s, .product_card_price_wrapper"
      ).each(function () {
        var text = jQ(this).text();
        text = text.replace(".00", "");
        jQ(this).text(text);
      });
    });

    // Intergrate Review Shopify
    if (
      window.SPR &&
      typeof window.SPR.initDomEls == "function" &&
      typeof window.SPR.loadBadges == "function" &&
      boostPFSThemeConfig.custom.show_product_review
    ) {
      window.SPR.initDomEls();
      window.SPR.loadBadges();
    }
  };
  // LAST ELEMENT END

  // Build additional elements
  Filter.prototype.afterRender = function (data) {
    if (!data) data = this.data;
    jQ("body").find(".boost-pfs-filter-skeleton-button").remove();
    announceFilterUpdate(data);
    // Prevent double tap on iOS
    var isiOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isiOS) {
      Utils.isMobile() &&
        jQ(".boost-pfs-filter-product-item")
          .find("a")
          .on("touchstart", function () {
            isScrolling = !1;
          })
          .on("touchmove", function () {
            isScrolling = !0;
          })
          .on("touchend", function () {
            isScrolling || (window.location = jQ(this).attr("href"));
          });
    }

    // Build Image Swap. Put this function here to impprove the pagespeed.
    swapImage(data);

    if (typeof boostRemoveImageLoadingAnimation == "function") {
      boostRemoveImageLoadingAnimation(
        jQ(Selector.products).find("[data-boost-image-loading-animation]")
      );
    }
    /* Filter Sticky */
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("enable_filter_sticky") &&
      boostPFSThemeConfig.custom.enable_filter_sticky &&
      !Utils.isMobile()
    ) {
      if (jQ(".boost-pfs-filter-left-col-inner").length > 0) {
        var stickyElemet = ".boost-pfs-filter-left-col-inner";
        var stickyElementParent = ".boost-pfs-filter-left-col";
        var startElement = ".boost-pfs-filter-products";
        jQ(stickyElemet).stickTo(startElement, stickyElementParent);
      }
    }
    /* End Filter Sticky */

    /* Init Sticky Mobile */
    stickyFilterMobile();
    jQ(window).scroll(stickyFilterMobile);

    /* Init Sticky Horizontal */
    stickyFilterHorizontal();
    jQ(window).scroll(stickyFilterHorizontal);

    /* Layout Fullwidth Page */
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("layout_type") &&
      boostPFSThemeConfig.custom.layout_type == "fullwidth" &&
      !Utils.isMobile()
    ) {
      jQ("body").addClass("boost-pfs-filter-fullwidth-page");
    }

    var ocFilter = document.getElementById("offcanvas_filter");
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var classes = $(mutation.target).prop(mutation.attributeName);
        ocFilter.setAttribute(
          "aria-hidden",
          classes.includes("show") ? "false" : "true"
        );
        ocFilter.setAttribute("tabindex", "-1");
        classes.includes("show") ? ocFilter.focus() : ocFilter.blur();
      });
    });

    observer.observe(ocFilter, {
      attributes: true,
      attributeFilter: ["class"],
    });
    window.addEventListener(
      "pageshow",
      function (evt) {
        if (evt.persisted && Utils.isiOS()) {
          location.reload();
        }
      },
      false
    );
  };

  /* Filter Sticky */
  jQ.fn.stickTo = function (startElement, stickyElementParent) {
    /* constants */
    var showingHeader = false;
    var headerHeight = 0; /* change the header height here */
    var headerSelector = "";
    var $window = jQ(window);
    var $startElement = jQ(startElement);
    var _this = this;

    /* variables */
    var lastScrollTop = $window.scrollTop();

    /* sticky method */
    var setPosition = function () {
      /* declarations */
      var width = jQ(stickyElementParent).outerWidth();
      var $windowHeight = $window.height();
      var $contentHeight = $startElement.outerHeight(true);
      var $contentTop = $startElement.offset().top;

      var sidebarHeight = _this.outerHeight();
      var sidebarTop = _this.offset().top;
      var sidebarBottom = sidebarTop + sidebarHeight;

      var scrollTop = $window.scrollTop();
      var scrollBottom = scrollTop + $windowHeight;
      var isScrollingDown = scrollTop > lastScrollTop;

      var endPos = $contentTop + $contentHeight;

      /* Match Header Height Sticky */

      if (jQ(".site-header-wrapper .action-area").length > 0) {
        /* For the Boundless theme */
        headerSelector = ".site-header-wrapper .action-area";
      } else if (jQ(".site-header .nav-bar").length > 0) {
        /* For the Venture theme */
        headerSelector = ".site-header .nav-bar";
      } else if (jQ(".site-header--fixed").length > 0) {
        headerSelector = ".site-header--fixed";
      } else if (jQ(".header-wrapper--fixed").length > 0) {
        headerSelector = ".header-wrapper--fixed";
      }

      if (headerSelector != "") {
        headerHeight = jQ(headerSelector).outerHeight();
      }

      jQ(window).scroll(function () {
        showingHeader = false;
        /* For the Boundless, Venture theme */
        if (
          jQ(".js-sticky-action-bar").length > 0 ||
          jQ(".site-header .sticky--open").length > 0 ||
          jQ(".site-header--fixed" || jQ(".header-wrapper--fixed"))
        ) {
          showingHeader = true;
        }
      });
      /* End Match Header Height Sticky */

      if (sidebarHeight > $contentHeight) {
        _this.removeClass("boost-pfs-filter-stick");
        jQ("body").removeClass("boost-pfs-filter-stick-vertical-body");
        _this.css({
          position: "initial",
        });
        return;
      }

      if (scrollTop <= $contentTop) {
        /* Initial Position */
        _this.removeClass("boost-pfs-filter-stick");
        jQ("body").removeClass("boost-pfs-filter-stick-vertical-body");
        _this.css({
          position: "initial",
        });
        return;
      }

      if (scrollBottom >= endPos) {
        /* End Position  */
        var absolutePos = endPos - sidebarHeight - $contentTop;
        if (absolutePos > 0) {
          _this.removeClass("boost-pfs-filter-stick");
          jQ("body").removeClass("boost-pfs-filter-stick-vertical-body");
          _this.css({
            position: "absolute",
            top: absolutePos,
            bottom: "unset",
            width: width,
          });
        }
        return;
      }
      /* when scrolling down */
      if (isScrollingDown) {
        if (scrollBottom < sidebarBottom) {
          /* Until reach the sidebar bottom  */
          if (_this.css("position") !== "relative") {
            _this.removeClass("boost-pfs-filter-stick");
            jQ("body").removeClass("boost-pfs-filter-stick-vertical-body");
            _this.css({
              position: "relative",
              top: sidebarTop - $contentTop,
              bottom: "unset",
            });
          }
        } else if (scrollBottom >= sidebarBottom && scrollTop > $contentTop) {
          /* Sticky sidebar */
          _this.addClass("boost-pfs-filter-stick");
          jQ("body").addClass("boost-pfs-filter-stick-vertical-body");

          _this.css({
            position: "fixed",
            top: showingHeader ? headerHeight + "px" : "20px",
            bottom: $windowHeight > sidebarHeight + headerHeight ? "unset" : 0,
            width: width,
            "max-height": "calc(100vh - 50px)",
            overflow: "auto",
            left: "auto",
          });
        }
      } else {
        /* when scrolling up */
        if (scrollTop - headerHeight > sidebarTop) {
          /* Until reach the sidebar top  */
          if (_this.css("position") !== "relative") {
            _this.removeClass("boost-pfs-filter-stick");
            jQ("body").removeClass("boost-pfs-filter-stick-vertical-body");
            _this.css({
              position: "relative",
              top: sidebarTop - $contentTop,
              bottom: "unset",
            });
          }
        } else if (scrollTop <= endPos - sidebarHeight) {
          /* Sticky sidebar */
          _this.addClass("boost-pfs-filter-stick");
          jQ("body").addClass("boost-pfs-filter-stick-vertical-body");

          _this.css({
            position: "fixed",
            top: showingHeader ? headerHeight + "px" : "20px",
            bottom: "unset",
            width: width,
            "max-height": "calc(100vh - 50px)",
            overflow: "auto",
            left: "auto",
          });
        }
      }

      /* save last scroll position */
      lastScrollTop = $window.scrollTop();
    };

    /* on window resize */
    jQ(window).resize(function () {
      setPosition();
    });

    /* on scroll */
    jQ(window).scroll(setPosition);
    setPosition();

    jQ(document).on(
      "click",
      ".boost-pfs-filter-button.boost-pfs-filter-option-title-heading",
      function () {
        setTimeout(setPosition, 400);
      }
    );
  };

  /* End filter sticky */

  var original_onClickEventProductDisplayType =
    ProductDisplayType.prototype._onClickEvent;
  ProductDisplayType.prototype._onClickEvent = function (event) {
    // Call the original function in our app lib.
    // We don't have to copy a very big function out here to modify.
    // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
    original_onClickEventProductDisplayType.call(this, event);

    // Do your custom code after the original function has run
    /*  View As Type 2/3/4/5/6 */
    if (
      boostPFSThemeConfig.custom.view_as_type ==
        "view_as_type_list_grid_multi_col" &&
      !Utils.isMobile()
    ) {
      jQ(".boost-pfs-filter-top-display-type").addClass(
        "boost-pfs-filter-view-as-click"
      );
      jQ(".boost-pfs-filter-top-display-type")
        .removeClass(function (index, css) {
          return (css.match(/(^|\s)grid-\S+/g) || []).join(" ");
        })
        .addClass(jQ(event.target).data("view"));
    }
  };

  // Swap Image
  function swapImage(data) {
    if (!Utils.isMobile()) {
      if (
        boostPFSThemeConfig.custom.hasOwnProperty("active_image_swap") &&
        boostPFSThemeConfig.custom.active_image_swap == true
      ) {
        var dataSrcSetFlipImg = "",
          dataSrcFlipImg = "",
          flipImageAlt = "",
          dataSizes = "auto",
          dataWidths = "",
          html = "";

        jQ(".boost-pfs-filter-product-item").each(function () {
          var productItemSelector = jQ(this);
          var imgSelector = productItemSelector.find(
            ".boost-pfs-filter-product-item-main-image"
          );

          if (
            typeof imgSelector.data("img-flip-src") != "undefined" &&
            imgSelector.data("img-flip-src") != ""
          ) {
            dataSrcFlipImg = imgSelector.data("img-flip-src");
            dataSrcSetFlipImg = imgSelector.data("img-flip-srcset");
            flipImageAlt = imgSelector.attr("alt");
            dataWidths = imgSelector.data("widths");
            html =
              '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
              'data-srcset="' +
              dataSrcSetFlipImg +
              '" ' +
              'data-src="' +
              dataSrcFlipImg +
              '" ' +
              'data-widths="[' +
              dataWidths +
              ']" ' +
              'data-sizes="' +
              dataSizes +
              '" ' +
              'src="' +
              boostPFSImgDefaultSrc +
              '" ' +
              'alt="' +
              flipImageAlt +
              '" />';

            productItemSelector
              .find(".boost-pfs-filter-product-item-image-link")
              .append(html);
          }
        });
      }
    }
  }

  // Build Placeholder for the first load
  function boostRemoveImageLoadingAnimation($selector) {
    if ($selector.length) {
      $selector.removeAttr("data-boost-image-loading-animation");
    }
  }
  /* Expand Filter */
  jQ(document).ready(function () {
    jQ(".boost-pfs-filter-custom-filter-button").on("click", function () {
      jQ("body").toggleClass("boost-pfs-filter-custom-drawer-open");
    });
    jQ(".boost-pfs-filter-custom-drawer-close").click(function () {
      jQ("body").removeClass("boost-pfs-filter-custom-drawer-open");
    });
    jQ(".boost-pfs-filter-custom-drawer-overlay").click(function () {
      jQ("body").removeClass("boost-pfs-filter-custom-drawer-open");
    });
  });

  /* Sticky Filter Mobile */
  function stickyFilterMobile() {
    var windowTop = jQ(window).scrollTop();
    var heightFooter = 0;
    var divTop = 0;
    var divHeight = 0;
    if (jQ("#shopify-section-footer").length > 0) {
      heightFooter = jQ("#shopify-section-footer").height();
    }
    if (jQ(".boost-pfs-filter-wrapper").length > 0) {
      divTop = jQ(".boost-pfs-filter-wrapper").offset().top;
    }
    if (jQ(".boost-pfs-filter-wrapper").length > 0) {
      divHeight = jQ(".boost-pfs-filter-wrapper").height();
    }

    if (windowTop > divTop + divHeight - heightFooter) {
      jQ("body").removeClass("boost-pfs-mobile-stick");
    } else if (windowTop > divTop) {
      jQ("body").addClass("boost-pfs-mobile-stick");
    } else {
      jQ("body").removeClass("boost-pfs-mobile-stick");
    }
  }

  /* Sticky Filter Desktop Horizontal */
  function stickyFilterHorizontal() {
    if (
      jQ(".boost-pfs-filter-tree-h-sticky-filter").length > 0 &&
      !Utils.isMobile()
    ) {
      var windowTop = jQ(window).scrollTop();
      var divTop = 0;
      if (jQ(".boost-pfs-filter-wrapper").length > 0) {
        divTop = jQ(".boost-pfs-filter-wrapper").offset().top;
      }

      if (windowTop > divTop) {
        jQ("body").addClass("boost-pfs-filter-horizontal-sticky-body");
      } else {
        jQ("body").removeClass("boost-pfs-filter-horizontal-sticky-body");
      }
    }
  }

  function announceFilterUpdate(data) {
    var announcer = document.getElementById('boost-pfs-filter-announcer');
    if (!announcer) return;
    
    var totalProducts = data.total_product || 0;
    var currentPage = parseInt(Globals.queryParams.page) || 1;
    var productsPerPage = Globals.queryParams.limit || 48;
    var displayedProducts = Math.min(productsPerPage, totalProducts - ((currentPage - 1) * productsPerPage));
    
    var message = '';
    
    var hasActiveFilters = false;
    var activeFilterCount = 0;
    
    if (Globals.queryParams.filter) {
      hasActiveFilters = true;
      for (var key in Globals.queryParams.filter) {
        if (Globals.queryParams.filter.hasOwnProperty(key)) {
          activeFilterCount++;
        }
      }
    }
    
    if (hasActiveFilters) {
      message = 'Filters applied. ';
    }
    
    message += 'Showing ' + displayedProducts + ' of ' + totalProducts + ' products';
    
    if (currentPage > 1) {
      message += ', page ' + currentPage;
    }
    
    message += '.';
    
    announcer.textContent = '';
    setTimeout(function() {
      announcer.textContent = message;
    }, 100);
  }

  function announceSortChange(sortLabel) {
    var announcer = document.getElementById('boost-pfs-filter-announcer');
    if (!announcer) return;
    
    announcer.textContent = '';
    setTimeout(function() {
      announcer.textContent = 'Products sorted by ' + sortLabel + '. Loading results.';
    }, 100);
  }
})();

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

function uniqArray(a) {
  return a.sort().filter(function (item, pos, ary) {
    return !pos || item != ary[pos - 1];
  });
}

String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
